import React from 'react';
import PersonCard from './PersonCard';

function Organization() {
  const people = [
    { id: 1, name: 'Dario Del Carratori', role: 'Presidente', image: '../images/logo_square.png' },
    { id: 2, name: 'Manuel Picchi', role: 'Vice Presidente', image: '../images/logo_square.png' },
    { id: 3, name: 'Dimitri Giani', role: 'Segretario', image: '../images/logo_square.png' },
    { id: 4, name: 'Virgilio Ruglioni', role: 'Consigliere', image: '../images/logo_square.png' },
    { id: 5, name: 'Luca Gracci', role: 'Consigliere', image: '../images/logo_square.png' },
  ];

  const topRow = people.filter(person => person.id <= 2);
  const bottomRow = people.filter(person => person.id > 2);


  return (
    <div className="organization-container">
      <h2>I membri</h2>
      
      {/* Prima riga */}
      <div className="row organization-content">
        {topRow.map(person => (
          <div key={person.id} className="col-lg-6 col-md-6 col-12">
            <PersonCard 
              image={person.image}
              name={person.name}
              role={person.role}
            />
          </div>
        ))}
      </div>
      
      {/* Seconda riga e successive */}
      <div className="row organization-content">
        {bottomRow.map(person => (
          <div key={person.id} className="col-lg-4 col-md-4 col-sm-12 ">
            <PersonCard 
              image={person.image}
              name={person.name}
              role={person.role}
            />
          </div>
        ))}
      </div>
    </div>
  );
}

export default Organization;